export default __webpack_public_path__ + "static/media/switch-logo.de262c25.svg";